// Arabic Industries index — mirrors the English Industries index but the
// AR industry slugs are Arabic-friendly SEO URLs, so each card links to
// /ar/industries/:arSlug (not the English slug).
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Seo } from "@/components/Seo";
import { ArPageHero, ArBlock, ArContactCTA } from "@/pages/ar/_ArShared";
import { Callout } from "@/components/InnerBlock";
import { INDUSTRIES_AR } from "@/data/industries-ar";

export default function IndustriesIndexAr() {
  const list = Object.values(INDUSTRIES_AR);
  return (
    <div data-testid="industries-index-ar">
      <Seo title="الصناعات" description="القطاعات التي صُممت منصاتنا ومنتجاتنا من أجلها." />
      <ArPageHero
        eyebrow="الصناعات"
        h1="الصناعات التي نبني من أجلها"
        sub="البرمجيات تفشل بطرق مختلفة في كل قطاع. منصة لوجستية تنهار عند التوزيع وانقطاع الإشارة. نظام رعاية صحية ينهار عند الموافقة والاحتفاظ بالبيانات. معرض سيارات ينهار عند مخزون أمانة لا يملكه أحد. نبني وفق نمط الفشل، لا الفئة."
        breadcrumbs={[{ label: "الرئيسية", to: "/ar" }, { label: "الصناعات" }]}
      />

      <ArBlock tint="white">
        <div className="mb-2 text-xs font-semibold uppercase tracking-widest text-wafa-primary">
          القطاعات التي صُممت منصاتنا ومنتجاتنا من أجلها.
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {list.map((it) => (
            <Link
              key={it.slug}
              to={`/ar/industries/${it.slug}`}
              data-testid={`index-card-ar-${it.slug}`}
              className="group flex flex-col rounded-lg border border-wafa-deep/10 bg-white p-6 transition-all duration-200 hover:-translate-y-1 hover:border-wafa-deep/25 hover:shadow-[0_18px_40px_-20px_rgba(14,79,58,0.25)]"
            >
              <div className="font-heading text-lg font-semibold text-wafa-deep group-hover:text-wafa-primary">
                {it.navLabel || it.h1}
              </div>
              {it.intro ? (
                <p className="mt-3 line-clamp-3 text-sm text-wafa-ink/70">
                  {it.intro.length > 160 ? it.intro.slice(0, 160) + "…" : it.intro}
                </p>
              ) : null}
              <div className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-wafa-deep">
                اقرأ المزيد <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-1" />
              </div>
            </Link>
          ))}
        </div>
      </ArBlock>

      <ArBlock tint="cream">
        <Callout>
          حيث لدينا منصات تعمل بالفعل، نذكر ذلك ونسمي المنصة. وحيث لا يوجد، نخبركم بما سنبنيه بدلًا من ذلك. لن تجدوا ادعاءات عملاء مختلقة في أي مكان على هذا الموقع.
        </Callout>
      </ArBlock>

      <ArContactCTA heading="غير متأكدين أيها يناسبكم؟" />
    </div>
  );
}
